var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusnew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/document"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.44449 1.16666H4.55616C2.43283 1.16666 1.16699 2.4325 1.16699 4.55583V9.43833C1.16699 11.5675 2.43283 12.8333 4.55616 12.8333H9.43866C11.562 12.8333 12.8278 11.5675 12.8278 9.44417V4.55583C12.8337 2.4325 11.5678 1.16666 9.44449 1.16666ZM9.18783 9.1875H4.81283C4.57366 9.1875 4.37533 8.98916 4.37533 8.75C4.37533 8.51083 4.57366 8.3125 4.81283 8.3125H9.18783C9.42699 8.3125 9.62533 8.51083 9.62533 8.75C9.62533 8.98916 9.42699 9.1875 9.18783 9.1875ZM9.18783 5.6875H4.81283C4.57366 5.6875 4.37533 5.48916 4.37533 5.25C4.37533 5.01083 4.57366 4.8125 4.81283 4.8125H9.18783C9.42699 4.8125 9.62533 5.01083 9.62533 5.25C9.62533 5.48916 9.42699 5.6875 9.18783 5.6875Z",
    fill: "#1A1A1A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusnew);
export default __webpack_public_path__ + "static/media/statusnew.94b757ecda90177747cf80159e659434.svg";
export { ForwardRef as ReactComponent };